import {loop, Effects} from 'redux-loop';
import _ from 'lodash';
import { FETCH_DOWN_LIMIT, FETCH_DOWN_LIMIT_SUCCESS } from './actions';
import { fetchDownLimitTasks } from './tasks';

const initialState = {
  dayDownLimit: 0
}

export default (state = initialState, action) => {

  if (action.type === FETCH_DOWN_LIMIT) {
    return loop({
      ...state,
    },
      Effects.promise(fetchDownLimitTasks, action.data)
    )
  }

  if (action.type === FETCH_DOWN_LIMIT_SUCCESS) {
    const datas = _.map(action.data.data, 'data.limit')
    return loop({
      ...state,
      dayDownLimit: _.sum(datas)
    },
      Effects.none()
    )
  }

  return loop(state, Effects.none())
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/elog/reducer.js
 **/